// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pNu27GKP5HjYU0j_RQOC {
    min-width: 0;
    border: 1px solid var(--mark-border);
    border-radius: 1.2rem;
    background: var(--mark-surface);
    overflow: hidden;
}
.fMqqR1wCg2Pl7zLrhe_3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1.2rem;
    padding: 1.2rem 1.6rem;
    border-bottom: 1px solid var(--mark-border);
}
.Pys4QGukEWPUEyiw9zDj {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}
.Pys4QGukEWPUEyiw9zDj strong {
    font-size: 1.5rem;
}
.rsSncn2Giq851CYrCdyQ {
    font-size: 1.3rem;
    line-height: 1.5;
    color: var(--mark-muted);
    margin: 0;
}
.UrpJre5T14zu3pQNe3rD {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    font-size: 1.3rem;
}
.JNqZCTlem5bpLk3CBfr6 {
    width: 4.2rem;
    text-align: center;
    color: var(--mark-muted);
}
.us_Hv2BqGpuP4IC6XPq_ {
    overflow: auto;
    max-height: 72vh;
    min-height: 34rem;
    padding: 0;
    background-color: var(--mark-surface);
    background-image: radial-gradient(var(--mark-border) 0.8px, transparent 0.8px);
    background-size: 20px 20px;
}
.us_Hv2BqGpuP4IC6XPq_:focus-visible {
    outline: 2px solid var(--mark-primary);
    outline-offset: -3px;
}
.gfNWrgo1j6IkFedtjDBQ {
    position: relative;
    margin: 0 auto;
}
.jrtRLqEQc6Nxr2yGTXYe {
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: top left;
}
.CgXKYJMkscBGv41Kzvx5 {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    overflow: visible;
}
.PtClq7hpsvGzHC_qUpBZ {
    fill: none;
    stroke: var(--mark-muted);
    stroke-width: 1.6;
    opacity: 0.6;
}
.bGsBOC2WkKdaw2DTDuUK {
    stroke: var(--mark-success);
    stroke-dasharray: 5 4;
    opacity: 0.9;
}
.rA_wlFssmKL4TyR5XHCS {
    stroke: var(--mark-danger);
    stroke-dasharray: 5 4;
    opacity: 1;
}
.MjVz4q5CRvLOus2G3tA1 {
    position: absolute;
    top: 1.6rem;
    width: 10.8rem;
    height: 2.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    border: 1px solid var(--mark-border);
    border-radius: 2rem;
    background: var(--mark-surface);
    color: var(--mark-muted);
    font-size: 1.2rem;
    font-weight: 600;
}
.MjVz4q5CRvLOus2G3tA1::before {
    content: '';
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    background: var(--mark-success);
}
.B4qSNYmElzCOD5H4UUe1 {
    position: absolute;
}
.V9vFVgfoCpg6prEZROFY {
    position: relative;
    cursor: pointer;
    border-radius: 1rem;
    outline: none;
}
.V9vFVgfoCpg6prEZROFY:hover .mCDnEgHtzHC4B6Uytn66,
.V9vFVgfoCpg6prEZROFY:focus-visible .mCDnEgHtzHC4B6Uytn66 {
    border-color: var(--mark-primary);
}
.V9vFVgfoCpg6prEZROFY:focus-visible {
    outline: 2px solid var(--mark-primary);
    outline-offset: 3px;
}
.V9vFVgfoCpg6prEZROFY[aria-pressed='true'] .mCDnEgHtzHC4B6Uytn66 {
    border-color: var(--mark-primary);
    box-shadow: 0 0 0 1px var(--mark-primary);
}
.mCDnEgHtzHC4B6Uytn66 {
    height: 16rem;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    padding: 1.6rem;
    border: 1px solid var(--mark-border);
    border-radius: 1rem;
    background: var(--mark-surface);
    box-shadow: 0 2px 5px rgb(0 0 0 / 4%);
    color: var(--mark-text);
}
.D6FGH_elaKUg8ywqgtwo {
    display: flex;
    align-items: center;
    gap: 1rem;
    min-width: 0;
}
.kc2O05zcgg6iGlq3Vu7Z {
    margin: 0;
    font-size: 1.6rem;
    line-height: 1.4;
    font-weight: 600;
}
.vO_Utngo7eIfWhaeTnYA {
    width: 3.2rem;
    height: 3.2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    border-radius: 0.8rem;
    background: var(--mark-selected);
    color: var(--mark-primary);
    font-size: 1.1rem;
    font-weight: 700;
}
.vO_Utngo7eIfWhaeTnYA svg {
    width: 2.2rem;
    height: 2.2rem;
}
.mCDnEgHtzHC4B6Uytn66[data-kind='check'] .vO_Utngo7eIfWhaeTnYA {
    background: var(--mark-surface);
    border: 1px solid var(--mark-border);
    color: var(--mark-muted);
}
.mCDnEgHtzHC4B6Uytn66[data-kind='split'] .vO_Utngo7eIfWhaeTnYA {
    background: var(--mark-warning-surface);
    color: var(--mark-warning);
}
.SFPTwsu4f2nsgPPpTzU5 {
    margin: 0;
    color: var(--mark-muted);
    font-size: 1.3rem;
    line-height: 1.5;
}
.QqKjawe1k5zYU3IXMS8K {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;
    margin-top: auto;
    min-width: 0;
}
.bcdnWo9LJ13rduUbfLHb {
    color: var(--mark-muted);
    font: 1.1rem/1.4 monospace;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0;
}
.NNE_Pnw4MTXdmZCHZm4Q {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    color: var(--mark-success);
    font-size: 1.1rem;
    white-space: nowrap;
}
.gwB84VG46nlDEzD4s4AC {
    display: flex;
    gap: 1.2rem;
    color: var(--mark-text);
    font-size: 1.3rem;
}
.gwB84VG46nlDEzD4s4AC span {
    flex: 1;
    padding: 0.6rem 0.8rem;
    border-radius: 0.4rem;
    background: var(--mark-warning-surface);
}
.FLWmcsurBwbjle4_ROIe {
    position: absolute;
    top: -0.8rem;
    right: 1rem;
    z-index: 1;
    color: var(--mark-primary);
    background: var(--mark-surface);
    padding: 0 0.5rem;
    font-size: 1.1rem;
    font-weight: 600;
}
.Rcu0CHXhhmzNYG53zfmQ {
    position: absolute;
    top: -0.8rem;
    left: 1rem;
    z-index: 1;
    color: var(--mark-danger);
    background: var(--mark-danger-surface);
    border: 1px solid var(--mark-danger);
    border-radius: 1rem;
    padding: 0.1rem 0.6rem;
    font-size: 1.1rem;
}
.VQp8ACWAGUTeM5kZYBGo {
    position: absolute;
    width: 10.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    z-index: 2;
}
.DXrmd7z107FYFyGrOhj5 {
    display: inline-flex;
    align-items: center;
    min-height: 2.6rem;
    padding: 0.2rem 0.4rem;
    background: var(--mark-surface);
    border: 1px solid var(--mark-border);
    border-radius: 1.6rem;
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--mark-muted);
    white-space: nowrap;
}
.yAUBopABn_feKImmc8sg {
    color: var(--mark-success);
    border-color: var(--mark-success);
}
.Wuatc89uzonf9HhMFIjf {
    color: var(--mark-danger);
    border-color: var(--mark-danger);
}
.VPuiukpszRfwyqSTBbhh {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    min-height: 7.6rem;
    box-sizing: border-box;
    padding: 1.2rem 1.6rem;
    border: 1px dashed var(--mark-border);
    border-radius: 1rem;
    background: var(--mark-surface);
    color: var(--mark-muted);
}
.VPuiukpszRfwyqSTBbhh strong {
    font-size: 1.3rem;
    font-weight: 600;
}
.VPuiukpszRfwyqSTBbhh p {
    margin: 0.4rem 0 0;
    font-size: 1.2rem;
    line-height: 1.4;
}
.PSoPBxSF2i0wZ9lXIsL1 {
    width: 2.4rem;
    height: 2.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    border: 1px solid var(--mark-border);
    border-radius: 50%;
    font-size: 1.3rem;
}
.Ek9BCtB_gOXKdHHYhwBL {
    border-color: var(--mark-danger);
    color: var(--mark-danger);
    background: var(--mark-danger-surface);
}
.Bmt4zVBNprQkiU1BNdNR {
    border-top: 1px solid var(--mark-border);
    padding: 1.6rem;
}
.Bmt4zVBNprQkiU1BNdNR summary {
    font-size: 1.4rem;
    font-weight: 600;
    cursor: pointer;
}
.s39ERS4vpyRVhRDgAaw5 {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 26.4rem), 1fr));
    gap: 1.6rem;
    margin-top: 1.6rem;
}
.IVxmrIq0soe30FIlPkFk {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.2rem;
    text-align: center;
    padding: 4.8rem 2.4rem;
    border: 1px dashed var(--mark-border);
    border-radius: 1.2rem;
    background: var(--mark-surface);
}
.IVxmrIq0soe30FIlPkFk h3 {
    margin: 0;
    font-size: 1.8rem;
}
.LYeVztLrvBxZIplAInXE {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    border-bottom: 1px solid var(--mark-border);
    padding-bottom: 1.2rem;
}
.aTYUjpfEjzrvEzYQEfsO {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.2rem;
    padding-top: 1.2rem;
    border-top: 1px solid var(--mark-border);
}
@media (max-width: 600px) {
    .fMqqR1wCg2Pl7zLrhe_3 {
        padding: 1.2rem;
    }
    .us_Hv2BqGpuP4IC6XPq_ {
        max-height: 65vh;
    }
    .Bmt4zVBNprQkiU1BNdNR {
        padding: 1.2rem;
    }
}

.EAcGz0QFNqNgVS9GTzZx {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
}

.tUVkuTaYrpD1npM3xuSL button[aria-haspopup='menu'] {
    width: 3.6rem !important;
    min-width: 3.6rem !important;
    min-height: 3.6rem !important;
    padding: 0 !important;
    border-radius: 50% !important;
}
.VQp8ACWAGUTeM5kZYBGo:focus-within {
    z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./pages/Mark/pages/Drips/StepCanvas/journey.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,oCAAoC;IACpC,qBAAqB;IACrB,+BAA+B;IAC/B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,qCAAqC;IACrC,8EAA8E;IAC9E,0BAA0B;AAC9B;AACA;IACI,sCAAsC;IACtC,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,oCAAoC;IACpC,mBAAmB;IACnB,+BAA+B;IAC/B,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,+BAA+B;AACnC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;AACA;;IAEI,iCAAiC;AACrC;AACA;IACI,sCAAsC;IACtC,mBAAmB;AACvB;AACA;IACI,iCAAiC;IACjC,yCAAyC;AAC7C;AACA;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,oCAAoC;IACpC,mBAAmB;IACnB,+BAA+B;IAC/B,qCAAqC;IACrC,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,gCAAgC;IAChC,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,+BAA+B;IAC/B,oCAAoC;IACpC,wBAAwB;AAC5B;AACA;IACI,uCAAuC;IACvC,0BAA0B;AAC9B;AACA;IACI,SAAS;IACT,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,OAAO;IACP,sBAAsB;IACtB,qBAAqB;IACrB,uCAAuC;AAC3C;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,0BAA0B;IAC1B,+BAA+B;IAC/B,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,yBAAyB;IACzB,sCAAsC;IACtC,oCAAoC;IACpC,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,UAAU;AACd;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;IAC/B,oCAAoC;IACpC,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,iCAAiC;AACrC;AACA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,qCAAqC;IACrC,mBAAmB;IACnB,+BAA+B;IAC/B,wBAAwB;AAC5B;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,sCAAsC;AAC1C;AACA;IACI,wCAAwC;IACxC,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;IACb,yEAAyE;IACzE,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,qCAAqC;IACrC,qBAAqB;IACrB,+BAA+B;AACnC;AACA;IACI,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,2CAA2C;IAC3C,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,wCAAwC;AAC5C;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,6BAA6B;IAC7B,qBAAqB;IACrB,6BAA6B;AACjC;AACA;IACI,WAAW;AACf","sourcesContent":[".journey {\n    min-width: 0;\n    border: 1px solid var(--mark-border);\n    border-radius: 1.2rem;\n    background: var(--mark-surface);\n    overflow: hidden;\n}\n.toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1.2rem;\n    padding: 1.2rem 1.6rem;\n    border-bottom: 1px solid var(--mark-border);\n}\n.toolbarCopy {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n.toolbarCopy strong {\n    font-size: 1.5rem;\n}\n.hint {\n    font-size: 1.3rem;\n    line-height: 1.5;\n    color: var(--mark-muted);\n    margin: 0;\n}\n.zoom {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    font-size: 1.3rem;\n}\n.zoomOutput {\n    width: 4.2rem;\n    text-align: center;\n    color: var(--mark-muted);\n}\n.scroller {\n    overflow: auto;\n    max-height: 72vh;\n    min-height: 34rem;\n    padding: 0;\n    background-color: var(--mark-surface);\n    background-image: radial-gradient(var(--mark-border) 0.8px, transparent 0.8px);\n    background-size: 20px 20px;\n}\n.scroller:focus-visible {\n    outline: 2px solid var(--mark-primary);\n    outline-offset: -3px;\n}\n.bounds {\n    position: relative;\n    margin: 0 auto;\n}\n.scene {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform-origin: top left;\n}\n.connections {\n    position: absolute;\n    top: 0;\n    left: 0;\n    pointer-events: none;\n    overflow: visible;\n}\n.link {\n    fill: none;\n    stroke: var(--mark-muted);\n    stroke-width: 1.6;\n    opacity: 0.6;\n}\n.loop {\n    stroke: var(--mark-success);\n    stroke-dasharray: 5 4;\n    opacity: 0.9;\n}\n.invalidLink {\n    stroke: var(--mark-danger);\n    stroke-dasharray: 5 4;\n    opacity: 1;\n}\n.start {\n    position: absolute;\n    top: 1.6rem;\n    width: 10.8rem;\n    height: 2.8rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.6rem;\n    border: 1px solid var(--mark-border);\n    border-radius: 2rem;\n    background: var(--mark-surface);\n    color: var(--mark-muted);\n    font-size: 1.2rem;\n    font-weight: 600;\n}\n.start::before {\n    content: '';\n    width: 0.6rem;\n    height: 0.6rem;\n    border-radius: 50%;\n    background: var(--mark-success);\n}\n.node {\n    position: absolute;\n}\n.interactive {\n    position: relative;\n    cursor: pointer;\n    border-radius: 1rem;\n    outline: none;\n}\n.interactive:hover .card,\n.interactive:focus-visible .card {\n    border-color: var(--mark-primary);\n}\n.interactive:focus-visible {\n    outline: 2px solid var(--mark-primary);\n    outline-offset: 3px;\n}\n.interactive[aria-pressed='true'] .card {\n    border-color: var(--mark-primary);\n    box-shadow: 0 0 0 1px var(--mark-primary);\n}\n.card {\n    height: 16rem;\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    padding: 1.6rem;\n    border: 1px solid var(--mark-border);\n    border-radius: 1rem;\n    background: var(--mark-surface);\n    box-shadow: 0 2px 5px rgb(0 0 0 / 4%);\n    color: var(--mark-text);\n}\n.cardHeader {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    min-width: 0;\n}\n.cardTitle {\n    margin: 0;\n    font-size: 1.6rem;\n    line-height: 1.4;\n    font-weight: 600;\n}\n.icon {\n    width: 3.2rem;\n    height: 3.2rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    border-radius: 0.8rem;\n    background: var(--mark-selected);\n    color: var(--mark-primary);\n    font-size: 1.1rem;\n    font-weight: 700;\n}\n.icon svg {\n    width: 2.2rem;\n    height: 2.2rem;\n}\n.card[data-kind='check'] .icon {\n    background: var(--mark-surface);\n    border: 1px solid var(--mark-border);\n    color: var(--mark-muted);\n}\n.card[data-kind='split'] .icon {\n    background: var(--mark-warning-surface);\n    color: var(--mark-warning);\n}\n.description {\n    margin: 0;\n    color: var(--mark-muted);\n    font-size: 1.3rem;\n    line-height: 1.5;\n}\n.cardFooter {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.8rem;\n    margin-top: auto;\n    min-width: 0;\n}\n.stepId {\n    color: var(--mark-muted);\n    font: 1.1rem/1.4 monospace;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    min-width: 0;\n}\n.badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    color: var(--mark-success);\n    font-size: 1.1rem;\n    white-space: nowrap;\n}\n.ratios {\n    display: flex;\n    gap: 1.2rem;\n    color: var(--mark-text);\n    font-size: 1.3rem;\n}\n.ratios span {\n    flex: 1;\n    padding: 0.6rem 0.8rem;\n    border-radius: 0.4rem;\n    background: var(--mark-warning-surface);\n}\n.selectedFlag {\n    position: absolute;\n    top: -0.8rem;\n    right: 1rem;\n    z-index: 1;\n    color: var(--mark-primary);\n    background: var(--mark-surface);\n    padding: 0 0.5rem;\n    font-size: 1.1rem;\n    font-weight: 600;\n}\n.errorFlag {\n    position: absolute;\n    top: -0.8rem;\n    left: 1rem;\n    z-index: 1;\n    color: var(--mark-danger);\n    background: var(--mark-danger-surface);\n    border: 1px solid var(--mark-danger);\n    border-radius: 1rem;\n    padding: 0.1rem 0.6rem;\n    font-size: 1.1rem;\n}\n.branch {\n    position: absolute;\n    width: 10.4rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.6rem;\n    z-index: 2;\n}\n.branchLabel {\n    display: inline-flex;\n    align-items: center;\n    min-height: 2.6rem;\n    padding: 0.2rem 0.4rem;\n    background: var(--mark-surface);\n    border: 1px solid var(--mark-border);\n    border-radius: 1.6rem;\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: var(--mark-muted);\n    white-space: nowrap;\n}\n.branchLoop {\n    color: var(--mark-success);\n    border-color: var(--mark-success);\n}\n.branchInvalid {\n    color: var(--mark-danger);\n    border-color: var(--mark-danger);\n}\n.finish {\n    display: flex;\n    align-items: center;\n    gap: 0.8rem;\n    min-height: 7.6rem;\n    box-sizing: border-box;\n    padding: 1.2rem 1.6rem;\n    border: 1px dashed var(--mark-border);\n    border-radius: 1rem;\n    background: var(--mark-surface);\n    color: var(--mark-muted);\n}\n.finish strong {\n    font-size: 1.3rem;\n    font-weight: 600;\n}\n.finish p {\n    margin: 0.4rem 0 0;\n    font-size: 1.2rem;\n    line-height: 1.4;\n}\n.finishIcon {\n    width: 2.4rem;\n    height: 2.4rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    border: 1px solid var(--mark-border);\n    border-radius: 50%;\n    font-size: 1.3rem;\n}\n.missing {\n    border-color: var(--mark-danger);\n    color: var(--mark-danger);\n    background: var(--mark-danger-surface);\n}\n.unreachable {\n    border-top: 1px solid var(--mark-border);\n    padding: 1.6rem;\n}\n.unreachable summary {\n    font-size: 1.4rem;\n    font-weight: 600;\n    cursor: pointer;\n}\n.unreachableGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(min(100%, 26.4rem), 1fr));\n    gap: 1.6rem;\n    margin-top: 1.6rem;\n}\n.empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.2rem;\n    text-align: center;\n    padding: 4.8rem 2.4rem;\n    border: 1px dashed var(--mark-border);\n    border-radius: 1.2rem;\n    background: var(--mark-surface);\n}\n.empty h3 {\n    margin: 0;\n    font-size: 1.8rem;\n}\n.inspectorHeader {\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem;\n    border-bottom: 1px solid var(--mark-border);\n    padding-bottom: 1.2rem;\n}\n.inspectorFooter {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1.2rem;\n    padding-top: 1.2rem;\n    border-top: 1px solid var(--mark-border);\n}\n@media (max-width: 600px) {\n    .toolbar {\n        padding: 1.2rem;\n    }\n    .scroller {\n        max-height: 65vh;\n    }\n    .unreachable {\n        padding: 1.2rem;\n    }\n}\n\n.srOnly {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip-path: inset(50%);\n    white-space: nowrap;\n    border: 0;\n}\n\n.addPath button[aria-haspopup='menu'] {\n    width: 3.6rem !important;\n    min-width: 3.6rem !important;\n    min-height: 3.6rem !important;\n    padding: 0 !important;\n    border-radius: 50% !important;\n}\n.branch:focus-within {\n    z-index: 10;\n}\n"],"sourceRoot":""}]);
// Exports
export var journey = `pNu27GKP5HjYU0j_RQOC`;
export var toolbar = `fMqqR1wCg2Pl7zLrhe_3`;
export var toolbarCopy = `Pys4QGukEWPUEyiw9zDj`;
export var hint = `rsSncn2Giq851CYrCdyQ`;
export var zoom = `UrpJre5T14zu3pQNe3rD`;
export var zoomOutput = `JNqZCTlem5bpLk3CBfr6`;
export var scroller = `us_Hv2BqGpuP4IC6XPq_`;
export var bounds = `gfNWrgo1j6IkFedtjDBQ`;
export var scene = `jrtRLqEQc6Nxr2yGTXYe`;
export var connections = `CgXKYJMkscBGv41Kzvx5`;
export var link = `PtClq7hpsvGzHC_qUpBZ`;
export var loop = `bGsBOC2WkKdaw2DTDuUK`;
export var invalidLink = `rA_wlFssmKL4TyR5XHCS`;
export var start = `MjVz4q5CRvLOus2G3tA1`;
export var node = `B4qSNYmElzCOD5H4UUe1`;
export var interactive = `V9vFVgfoCpg6prEZROFY`;
export var card = `mCDnEgHtzHC4B6Uytn66`;
export var cardHeader = `D6FGH_elaKUg8ywqgtwo`;
export var cardTitle = `kc2O05zcgg6iGlq3Vu7Z`;
export var icon = `vO_Utngo7eIfWhaeTnYA`;
export var description = `SFPTwsu4f2nsgPPpTzU5`;
export var cardFooter = `QqKjawe1k5zYU3IXMS8K`;
export var stepId = `bcdnWo9LJ13rduUbfLHb`;
export var badge = `NNE_Pnw4MTXdmZCHZm4Q`;
export var ratios = `gwB84VG46nlDEzD4s4AC`;
export var selectedFlag = `FLWmcsurBwbjle4_ROIe`;
export var errorFlag = `Rcu0CHXhhmzNYG53zfmQ`;
export var branch = `VQp8ACWAGUTeM5kZYBGo`;
export var branchLabel = `DXrmd7z107FYFyGrOhj5`;
export var branchLoop = `yAUBopABn_feKImmc8sg`;
export var branchInvalid = `Wuatc89uzonf9HhMFIjf`;
export var finish = `VPuiukpszRfwyqSTBbhh`;
export var finishIcon = `PSoPBxSF2i0wZ9lXIsL1`;
export var missing = `Ek9BCtB_gOXKdHHYhwBL`;
export var unreachable = `Bmt4zVBNprQkiU1BNdNR`;
export var unreachableGrid = `s39ERS4vpyRVhRDgAaw5`;
export var empty = `IVxmrIq0soe30FIlPkFk`;
export var inspectorHeader = `LYeVztLrvBxZIplAInXE`;
export var inspectorFooter = `aTYUjpfEjzrvEzYQEfsO`;
export var srOnly = `EAcGz0QFNqNgVS9GTzZx`;
export var addPath = `tUVkuTaYrpD1npM3xuSL`;
export default ___CSS_LOADER_EXPORT___;
